/* eslint-disable no-undef */
export const targetId = "UA-148500286-1";
export const virtualView = () => gtag("config", targetId, {
    page_title: document.title,
    page_path: `${window.location.pathname}${window.location.search}`,
    path_location: window.location.href,
});
